import Gateway from './gateway';
import { GatewayResponse, ProtectedRoute } from '~types/gateway';

import {
    TCreateBuyGoldTransactionAPIParams,
    TCreateInventoryAPIParams,
    TCreateTransactionDraftAPIParams,
    TCreateTransactionDraftResponse,
    TExportInventoryTransactionListingAPIResponse,
    TGetGoldPricesAPIResponse,
    TGetInventoryFilterAPIParams,
    TGetInventoryFilterAPIResponse,
    TGetInventoryListingAPIParams,
    TGetInventoryListingAPIResponse,
    TGetInventoryTransactionListingAPIParams,
    TGetInventoryTransactionListingAPIResponse,
    TGetProductFilterAPIParams,
    TGetProductFilterAPIResponse,
    TGetSerialNumberFilterAPIParams,
    TGetSerialNumberFilterAPIResponse,
    TGetTotalNetValueOrQuantityAPIParams,
    TGetTransactionListingAPIParams,
    TGetTransactionListingAPIResponse,
    TGetTransactionReceiptAPIParams,
    TGoldTransactionListing,
    TTransferInventoryAPIParams,
    TGetInventoryTransfersAPIParams,
    TGetInventoryTransfersAPIResponse,
    TGetBranchMarketStatusAPIParams,
    TGetBranchMarketStatusBranchAPIResponse,
} from '~types/feat/gold';
import { TGetInventoryTransferListingAPIParams, TGetInventoryTransferListingAPIResponse } from '~types/feat/setting';
import { TCreateStockOutAPIParams, TGetStockOutsAPIParams, TGetStockOutsAPIResponse, TgetStockOutTransactionsListingAPIResponse, TGetStockOutTransactionsListingParams, TGetStockOutTransactionsAPIParams } from '~types/feat/stockOut';

export abstract class IGoldGateway extends Gateway {
    abstract getTransactionListing(params: TGetTransactionListingAPIParams): GatewayResponse<TGetTransactionListingAPIResponse | null>;

    abstract getGoldPrices(params: ProtectedRoute): GatewayResponse<TGetGoldPricesAPIResponse | null>;

    abstract createBuyGoldTransaction(params: TCreateBuyGoldTransactionAPIParams): GatewayResponse<string | null>;

    abstract createSellGoldTransaction(params: TCreateBuyGoldTransactionAPIParams): GatewayResponse<string | null>;

    abstract createTransactionDraft(params: TCreateTransactionDraftAPIParams): GatewayResponse<TCreateTransactionDraftResponse>;

    abstract getTransactionReceipt(params: TGetTransactionReceiptAPIParams): GatewayResponse<Blob>;

    // gold inventory
    abstract getInventoryTransactionListing(params: TGetInventoryTransactionListingAPIParams): GatewayResponse<TGetInventoryTransactionListingAPIResponse | null>;

    abstract getInventoryListing(params: TGetInventoryListingAPIParams): GatewayResponse<TGetInventoryListingAPIResponse | null>;

    abstract createInventory(params: TCreateInventoryAPIParams): GatewayResponse<string | null>;

    abstract transferInventory(params: TTransferInventoryAPIParams): GatewayResponse<string | null>;

    abstract exportInventoryTransactionListing(params: ProtectedRoute): GatewayResponse<TExportInventoryTransactionListingAPIResponse>;

    abstract exportGoldTransactionListing(params: ProtectedRoute): GatewayResponse<TGoldTransactionListing[]>;

    abstract getTotalNetValueOrQuantity(params: TGetTotalNetValueOrQuantityAPIParams): GatewayResponse<string | null>;

    //others
    abstract getAllProducts(params: TGetProductFilterAPIParams): GatewayResponse<TGetProductFilterAPIResponse>;

    abstract getAllInventories(params: TGetInventoryFilterAPIParams): GatewayResponse<TGetInventoryFilterAPIResponse>;

    abstract getAllSerialNumbers(params: TGetSerialNumberFilterAPIParams): GatewayResponse<TGetSerialNumberFilterAPIResponse>;

    abstract getInventoryTransferListing(params: TGetInventoryTransferListingAPIParams): GatewayResponse<TGetInventoryTransferListingAPIResponse>;

    abstract getInventoryTransfers(params: TGetInventoryTransfersAPIParams): GatewayResponse<TGetInventoryTransfersAPIResponse>;

    // Stock out
    abstract getStockOutListing(params: TGetStockOutsAPIParams): GatewayResponse<TGetStockOutsAPIResponse | null>;

    abstract createStockOut(params: TCreateStockOutAPIParams): GatewayResponse<string | null>;

    abstract getBranchMarketStatus(params: TGetBranchMarketStatusAPIParams): GatewayResponse<TGetBranchMarketStatusBranchAPIResponse>;

    abstract getStockOutTransactionsListing(params: TGetStockOutTransactionsAPIParams): GatewayResponse<TgetStockOutTransactionsListingAPIResponse | null>;
}
